// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process-selector {
  background: #fff;
  border-radius: 16px;
  /* box-shadow: 0 4px 24px rgba(0,0,0,0.08); */
  padding: 1rem 2rem 1rem 2rem;
  margin-bottom: 1rem;
  /* max-width: 900px; */
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  box-sizing: border-box;
}
.process-selector h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
}
.selector-group {
  margin-bottom: 1.2rem;
}
.selector-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #555;
}
.selector-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
  margin-bottom: 0.5rem;
}
.selector-btn {
  background: #f5f7fa;
  border: 1px solid #c3cfe2;
  color: #333;
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.selector-btn.selected, .selector-btn:active {
  background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%);
  color: #fff;
  border-color: #2193b0;
  transform: translateY(-3px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 12px rgba(33, 147, 176, 0.3);
}
.selector-btn:hover {
  background: #e3eafc;
  color: #2193b0;
}
.selector-actions {
  text-align: right;
  margin-top: 1rem;
}
.btn.btn-secondary {
  background: #6c757d;
  color: #fff;
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.btn.btn-secondary:hover {
  background: #495057;
}

@media (max-width: 700px) {
  .process-selector {
    padding: 1rem 0.5rem;
  }
  .selector-options {
    flex-direction: column;
    gap: 0.4rem;
  }
  .selector-actions {
    text-align: center;
  }
}

.fade-in {
  animation: fadeInStep 0.5s ease;
}
@keyframes fadeInStep {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Темная тема для process-selector */
.dark-theme .process-selector {
  background: #2d2d2d;
  border: 1px solid #4a5568;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
}

.dark-theme .process-selector h2 {
  color: #ffffff;
}

.dark-theme .selector-label {
  color: #e2e8f0;
}

.dark-theme .selector-btn {
  background: #3d3d3d;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.dark-theme .selector-btn:hover {
  background: #4a5568;
  color: #ffffff;
}

.dark-theme .selector-btn.selected,
.dark-theme .selector-btn:active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  border-color: #667eea;
}

.dark-theme .btn.btn-secondary {
  background: #4a5568;
  color: #ffffff;
}

.dark-theme .btn.btn-secondary:hover {
  background: #2d3748;
} `, "",{"version":3,"sources":["webpack://./src/components/parser/ProcessSelector.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,6DAA6D;EAC7D,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,qDAAqD;EACrD,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".process-selector {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  /* box-shadow: 0 4px 24px rgba(0,0,0,0.08); */\r\n  padding: 1rem 2rem 1rem 2rem;\r\n  margin-bottom: 1rem;\r\n  /* max-width: 900px; */\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n.process-selector h2 {\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.6rem;\r\n  font-weight: 700;\r\n  color: #333;\r\n}\r\n.selector-group {\r\n  margin-bottom: 1.2rem;\r\n}\r\n.selector-label {\r\n  font-weight: 500;\r\n  margin-bottom: 0.5rem;\r\n  color: #555;\r\n}\r\n.selector-options {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.7rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n.selector-btn {\r\n  background: #f5f7fa;\r\n  border: 1px solid #c3cfe2;\r\n  color: #333;\r\n  padding: 0.5rem 1.2rem;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n.selector-btn.selected, .selector-btn:active {\r\n  background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%);\r\n  color: #fff;\r\n  border-color: #2193b0;\r\n  transform: translateY(-3px);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(33, 147, 176, 0.3);\r\n}\r\n.selector-btn:hover {\r\n  background: #e3eafc;\r\n  color: #2193b0;\r\n}\r\n.selector-actions {\r\n  text-align: right;\r\n  margin-top: 1rem;\r\n}\r\n.btn.btn-secondary {\r\n  background: #6c757d;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.5rem 1.2rem;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n.btn.btn-secondary:hover {\r\n  background: #495057;\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .process-selector {\r\n    padding: 1rem 0.5rem;\r\n  }\r\n  .selector-options {\r\n    flex-direction: column;\r\n    gap: 0.4rem;\r\n  }\r\n  .selector-actions {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.fade-in {\r\n  animation: fadeInStep 0.5s ease;\r\n}\r\n@keyframes fadeInStep {\r\n  from { opacity: 0; transform: translateY(20px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n/* Темная тема для process-selector */\r\n.dark-theme .process-selector {\r\n  background: #2d2d2d;\r\n  border: 1px solid #4a5568;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.dark-theme .process-selector h2 {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .selector-label {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .selector-btn {\r\n  background: #3d3d3d;\r\n  border: 1px solid #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .selector-btn:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .selector-btn.selected,\r\n.dark-theme .selector-btn:active {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: #ffffff;\r\n  border-color: #667eea;\r\n}\r\n\r\n.dark-theme .btn.btn-secondary {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .btn.btn-secondary:hover {\r\n  background: #2d3748;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
